import { useTranslation } from 'react-i18next';
import { ContentEditor } from '@/Domain/components/Shared/ContentEditor/ContentEditor';
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
} from '@/Domain/components/Shared/Form/Form';
import { Input } from '@/Domain/components/Shared/Input/Input';
import {
  Item,
  ItemActions,
  ItemContent,
  ItemDescription,
  ItemTitle,
} from '@/Domain/components/Shared/Item/Item';
import { Switch } from '@/Domain/components/Shared/Switch/Switch';

export const PreChatSection = () => {
  const { t } = useTranslation(['widget', 'website']);

  return (
    <div className="flex flex-col gap-10">
      <Item variant="muted" className="w-full" size="sm">
        <ItemContent>
          <ItemTitle className="line-clamp-1">{t('website:pre_chat.title')}</ItemTitle>
          <ItemDescription>{t('website:pre_chat.description')}</ItemDescription>
        </ItemContent>
        <ItemActions className="shrink-0">
          <FormField
            name="prechat_active"
            render={({ field }) => (
              <Switch id={field.name} checked={field.value} onCheckedChange={field.onChange} />
            )}
          />
        </ItemActions>
      </Item>

      <div className="flex flex-col gap-8">
        <div className="grid grid-cols-2 gap-4">
          <FormField
            name="prechat_header_text"
            render={({ field }) => (
              <FormItem data-testid="field-prechat_header_text">
                <FormLabel>{t('prechat_header_text.label')}</FormLabel>
                <FormDescription>{t('prechat_header_text.description')}</FormDescription>
                <FormControl>
                  <Input size="sm" {...field} placeholder={t('prechat_header_text.placeholder')} />
                </FormControl>
              </FormItem>
            )}
          />

          <FormField
            name="prechat_button_text"
            render={({ field }) => (
              <FormItem data-testid="field-prechat_button_text">
                <FormLabel>{t('prechat_button_text.label')}</FormLabel>
                <FormDescription>{t('prechat_button_text.description')}</FormDescription>
                <FormControl>
                  <Input size="sm" {...field} placeholder={t('prechat_button_text.placeholder')} />
                </FormControl>
              </FormItem>
            )}
          />
        </div>

        <FormField
          name="prechat_message_text"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t('prechat_message_text.label')}</FormLabel>
              <FormDescription>{t('prechat_message_text.description')}</FormDescription>
              <FormControl>
                <ContentEditor value={field.value} onChange={field.onChange} />
              </FormControl>
            </FormItem>
          )}
        />
      </div>
    </div>
  );
};
